import { Edit, Eye, MoreHorizontal, Trash } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../ui/button";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuItem,
} from "../../ui/dropdown-menu";
import { AlertModal } from "../../modal/alert-modal";
import { deleteStatuts } from "../../../API/Mediatheque/Statuts/statutsService";

interface CellActionProps {
  data: any;
}

export const CellAction: React.FC<CellActionProps> = ({ data }) => {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const onConfirm = async () => {
    await deleteStatuts(data.id);
    setTimeout(() => {
      router(0);
    }, 3000);
  };
  const router = useNavigate();

  const openFile = (file: any) => {
    const uploadUrl = process.env.REACT_APP_FILE_UPLOAD;
    const fileUrl = `${uploadUrl}/medias/statuts/${encodeURIComponent(file)}`;

    window.open(fileUrl, "_blank");
  };

  return (
    <>
      <AlertModal
        isOpen={open}
        onClose={() => setOpen(false)}
        onConfirm={onConfirm}
      />
      <DropdownMenu modal={false}>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" className="w-8 h-8 p-0">
            <span className="sr-only">Open menu</span>
            <MoreHorizontal className="w-4 h-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuLabel>Actions</DropdownMenuLabel>

          <DropdownMenuItem onClick={() => openFile(data?.file)}>
            <Eye className="w-4 h-4 mr-2" /> Consulter
          </DropdownMenuItem>

          <DropdownMenuItem
            onClick={() =>
              router(`/admin-dashboard/mediatheque/statuts/${data.id}`)
            }
          >
            <Edit className="w-4 h-4 mr-2" /> Modifier
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => setOpen(true)}>
            <Trash className="w-4 h-4 mr-2" /> Supprimer
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
};
